import { appInsights } from './appInsights';

export const errorLogging = () => {

    const handleHttpError = (error: any) => {
        if (error.response) {
            appInsights.trackException(error);
        } else if (error.request) {
            console.log(`Request was made but no response ${error.request}`)
        } else {
            console.log(`${error.message}`)
        }
        console.log(error.config);
        appInsights.trackException(error);
    }

    const handleDexieError = (error: any): any[] => {
        console.warn(`DB ERROR: ${error.message}`)
        appInsights.trackException(error);
        return []
    }

    const handleDexieObjectError = (error: any): any => {
        console.warn(`${error.message}`)
        appInsights.trackException(error);
        return undefined
    }

    return {
        handleHttpError: handleHttpError,
        handleDexieError: handleDexieError,
        handleDexieObjectError: handleDexieObjectError
    }

}